import { CouponStatus } from './common';

export const CouponStatusKr : Record<CouponStatus, string> = {
  ISSUED: '발급됨',
  USED: '사용완료',
  EXPIRED: '기간만료',
  CANCELLED: '취소',
};
